import { useTranslation } from 'react-i18next';
import FeatureModule from "../Feature";
import {FoodStoreGrid} from "../FoodStoreGrid";
import {storesConfig} from "../../common/store-config";
import "./index.css"
import React, { useEffect, useRef } from "react";
import {partners} from "../../common/config";
import Bake from "./bake";
import ContactUs from "../contact";
import { useSearchParams } from 'react-router-dom';
import Footer from "../pegeFooter";

function Main() {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    // 使用useEffect确保代码在组件挂载后执行
    const targetComponentRef = useRef(null); // 创建ref

    useEffect(() => {
        // 当组件挂载完成后，执行滚动
        if (targetComponentRef.current && searchParams.get('scrollToContact')) {
            // @ts-ignore
            targetComponentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, []); // 空依赖数组保证effect只运行一次

    return (
        <main>
            <div className="slider-area ">
                <div className="slider-active slick-initialized slick-slider">
                    <div className="slick-list draggable">
                        <div className="slick-track" style={{ opacity: 1, width: 6880 }}>
                            <div
                                className="single-slider slider-height slider-padding sky-blue d-flex align-items-center slick-slide slick-current slick-active"
                                data-slick-index={0}
                                aria-hidden="false"
                                tabIndex={0}
                                style={{
                                    width: '100vw'
                                }}
                            >
                                <div className="container">
                                    <div className="row d-flex align-items-center">
                                        <div className="col-lg-6 col-md-9 ">
                                            <div className="hero__caption">
                                                <span
                                                    data-animation="fadeInUp"
                                                    data-delay=".4s"
                                                    className=""
                                                    style={{ animationDelay: "0.4s" }}
                                                >
                                                    {t('forRes')}
                                                </span>
                                                <h1
                                                    data-animation="fadeInUp"
                                                    data-delay=".6s"
                                                    className=""
                                                    style={{ animationDelay: "0.6s" }}
                                                >
                                                    {t('orderMultiTitle1')}
                                                    <br />
                                                    {t('orderMultiTitle2')}
                                                </h1>
                                                <p
                                                    data-animation="fadeInUp"
                                                    data-delay=".8s"
                                                    className=""
                                                    style={{ animationDelay: "0.8s" }}
                                                >
                                                    {t('mainDes')}
                                                </p>
                                                <div className="slider-btns">
                                                    <a
                                                        data-animation="fadeInLeft"
                                                        data-delay="1.0s"
                                                        href="/hybrid/downloadCenter.html"
                                                        className="btn radius-btn"
                                                        tabIndex={0}
                                                        style={{ animationDelay: "1s", zIndex: 1000 }}
                                                    >
                                                        {t('download')}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div
                                                className="hero__img d-none d-lg-block f-right"
                                                data-animation="fadeInRight"
                                                data-delay="1s"
                                                style={{ animationDelay: "1s" }}
                                            >
                                                <img
                                                    src="./main.png"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="single-slider slider-height slider-padding sky-blue d-flex align-items-center slick-slide"
                                data-slick-index={1}
                                aria-hidden="true"
                                tabIndex={-1}
                                style={{
                                    width: 3440,
                                    position: "relative",
                                    left: "-3440px",
                                    top: 0,
                                    zIndex: 998,
                                    opacity: 0
                                }}
                            >
                                <div className="container">
                                    <div className="row d-flex align-items-center">
                                        <div className="col-lg-6 col-md-9 ">
                                            <div className="hero__caption">
                                                <span data-animation="fadeInUp" data-delay=".4s">
                                                    App Landing Page
                                                </span>
                                                <h1 data-animation="fadeInUp" data-delay=".6s">
                                                    Get things done
                                                    <br />
                                                    with Appco
                                                </h1>
                                                <p data-animation="fadeInUp" data-delay=".8s">
                                                    Dorem ipsum dolor sitamet, consectetur adipiscing elit,
                                                    sed do eiusm tempor incididunt ulabore et dolore magna
                                                    aliqua.
                                                </p>
                                                <div className="slider-btns">
                                                    <a
                                                        data-animation="fadeInLeft"
                                                        data-delay="1.0s"
                                                        href="https://preview.colorlib.com/theme/appco/industries.html"
                                                        className="btn radius-btn"
                                                        tabIndex={-1}
                                                    >
                                                        Download
                                                    </a>
                                                    <a
                                                        data-animation="fadeInRight"
                                                        data-delay="1.0s"
                                                        className="popup-video video-btn ani-btn"
                                                        href="https://www.youtube.com/watch?v=1aP-TXUpNoU"
                                                        tabIndex={-1}
                                                    >
                                                        <i className="fas fa-play" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div
                                                className="hero__img d-none d-lg-block f-right"
                                                data-animation="fadeInRight"
                                                data-delay="1s"
                                            >
                                                <img
                                                    src="./App Landing Template_files/xhero_right.png.pagespeed.ic.GkpyOQDTCI.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FeatureModule />
            <div>
                <div className='my-title-wrap'>
                    <h2 className="section-title">{t('partners')}</h2>
                </div>
                <FoodStoreGrid
                  stores={partners}
                />
            </div>
            <div ref={targetComponentRef}>
                <ContactUs/>
            </div>
            <div>
                <Footer />
            </div>

            {/*暂时用不上的*/}
            <Bake />
        </main>

    );
}

export default Main;
